import { render, staticRenderFns } from "./PaymentApprovalTable.vue?vue&type=template&id=05f51ea8"
import script from "./PaymentApprovalTable.vue?vue&type=script&lang=js"
export * from "./PaymentApprovalTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports